// src/redux/actions/salesActions.js
import { 
    FETCH_SALES_WALKTHROUGH_REQUEST, 
    FETCH_SALES_WALKTHROUGH_SUCCESS, 
    FETCH_SALES_WALKTHROUGH_FAILURE 
} from '../../../../Constants/actionTypes';
import { fetchSalesWalkthorugh } from '../../../../Constants/apiService'

// Fetch Sales Request Action
export const fetchSalesWalkthroughRequest = () => ({
    type: FETCH_SALES_WALKTHROUGH_REQUEST,
});

// Fetch Sales Success Action
export const fetchSalesWalkthroughSuccess = (salesData) => ({
    type: FETCH_SALES_WALKTHROUGH_SUCCESS,
    payload: salesData,
});

// Fetch Sales Failure Action
export const fetchSalesWalkthroughFailure = (error) => ({
    type: FETCH_SALES_WALKTHROUGH_FAILURE,
    payload: error,
});

// Thunk Action Creator for Fetching Sales
export const fetchWalkthroughSales = () => {
    return async (dispatch, getState) => {
        dispatch(fetchSalesWalkthroughRequest());

        const state = getState();
        const accessToken = state.auth.accessToken; 


        try {
            const data = await fetchSalesWalkthorugh(accessToken);
            console.log(data)
            dispatch(fetchSalesWalkthroughSuccess(data));
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch(fetchSalesWalkthroughFailure(errorMessage));
        }
    };
};
